'use strict';
require('./typeahead');
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.findFileWidget = function (editorUrl, goldFileListModel, navigatorShim) {
	return mmWidgets.each(this, function () {
		const self = this,
			findFile = function (str) {
				const fileList = goldFileListModel.getCurrentList();
				return fileList.filter(function (item) {
					return item && item.description && item.description.toLocaleLowerCase && item.description.toLocaleLowerCase().indexOf(str.toLocaleLowerCase()) > -1;
				});
			},
			openMap = function (listItem) {
				if (listItem && listItem.url) {
					navigatorShim.redirect(editorUrl + '/' + listItem.url);
				}
				self.trigger('show');
			},
			formatTitle = function (domEl, fileItem) {
				const title = fileItem.description,
					formatted = title.replace(/\n/g, ' ');
				domEl.text(formatted);
			};
		self.on('keyup', function (e) {
			if (e.which === 27) {
				self.trigger('show');
			}
		});

		self.typeahead(findFile, openMap, formatTitle);
	});
};
